import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";
import { TopbarHomeIcon } from "./TopbarHomeIcon";
import { TopbarLanguage } from "./TopbarLanguage";
import { TopbarACALogo } from "./TopbarACALogo";
import { TopbarTheme } from "./TopbarTheme";
import { EmojiBar } from "./EmojiBar";
import "./Topbar.css";
import * as helpers from "../helpers";

const Topbar = ({ i18n, refLang, pagePath }) => {
  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;
  return (
    <div
      className={theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"}
      id="topbar"
    >
      <div
        id="topbar-icons"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!helpers.isWhiteLabelDomain(
          process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN
        ) && <TopbarHomeIcon i18n={i18n} />}
        {helpers.isWhiteLabelDomain(
          process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN
        ) && <TopbarACALogo />}
        {!helpers.isWhiteLabelDomain(
          process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN
        ) && (
          <>
            <TopbarLanguage i18n={i18n} pagePath={pagePath} ref={refLang} />
            <TopbarTheme />
          </>
        )}
      </div>

      {!helpers.isWhiteLabelDomain(
        process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN
      ) && <EmojiBar i18n={i18n} />}
    </div>
  );
};

export { Topbar };
